"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.OrderStore = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _head3 = _interopRequireDefault(require("lodash/head"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _hotelCart = require("../../clients/hotel-cart.client");
var _cart = require("@tajawal/web-core-sdk-v2/lib/clients/cart.client");
var _flightCart = require("../../clients/flight-cart.client");
var _accommodationCart = require("../../clients/accommodation-cart.client");
var _chalet = require("@tajawal/guest-sdk/lib/factories/chalet.factory");
var _flightProduct = require("../../factories/flight-product.factory");
var _flightProduct2 = _interopRequireDefault(require("@tajawal/web-flights-sdk/lib/factories/flight-product.factory"));
var _orderContact = require("../../factories/order-contact.factory");
var _orderKnet = require("../../factories/order-knet.factory");
var _loyaltyProduct = require("../../factories/loyalty-product.factory");
var _couponProduct = require("../../factories/coupon-product.factory");
var _ruleProduct = require("../../factories/rule-product.factory");
var _cartProduct = require("@tajawal/web-core-sdk-v2/lib/utils/cart-product.utils");
var _cartProduct2 = require("../../utils/cart-product.utils");
var _constants2 = require("../../constants");
var _mobxUtils = require("mobx-utils");
var _hotelProduct = require("@tajawal/web-hotel-sdk-v2/lib/factories/hotel-product.factory");
var _dateFns = require("date-fns");
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
const {
  INITIAL,
  LOADING,
  SUCCESS,
  FAILED
} = _constants.API_STATE;
const {
  FURSAN,
  QITAF,
  WALLET,
  MOKAFAA
} = _constants2.LOYALTY_METHODS;
const {
  CHECKOUTCOM,
  PAYFORT,
  FORT,
  TAJAWAL_PAY,
  PAY_LATER
} = _constants2.PAYMENT_METHODS;

/**
 * order store
 */
let OrderStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function OrderStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, OrderStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor2, this);
    /**
     * get guest
     * @return {Object}
     */
    this.getGuest = (0, _mobxUtils.computedFn)(index => (0, _get2.default)(this, `guests.${index}`, (0, _head3.default)(this.guests)));
    /**
     * get hotel order by orderId and orderNumber
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.orderId
     * @param {string} prop.payload.orderNumber
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(this, "getHotelOrder", _descriptor3, this);
    /**
     * get accommodation order by orderId
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.orderId
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(this, "getAccommodationOrder", _descriptor4, this);
    /**
     * get flight order by orderId and orderNumber
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.orderId
     * @param {string} prop.payload.orderNumber
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(this, "getFlightOrder", _descriptor5, this);
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(OrderStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function () {
      return this.API_STATE === LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function () {
      return this.API_STATE === SUCCESS;
    }

    /**
     * is error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function () {
      return this.API_STATE === FAILED;
    }

    /**
     * cart id
     * @return {string}
     */
  }, {
    key: "cartId",
    get: function () {
      return (0, _get2.default)(this.data, 'cartId');
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */
  }, {
    key: "modifiedCartId",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.cartId');
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */
  }, {
    key: "entityType",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.entityType');
    }

    /**
     * order number
     * @return {string}
     */
  }, {
    key: "orderNumber",
    get: function () {
      return (0, _get2.default)(this.data, 'orderNumber');
    }

    /**
     * payment method
     * @return {string}
     */
  }, {
    key: "paymentMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.paymentMethod');
    }

    /**
     * created at
     * @return {Date}
     */
  }, {
    key: "createdAt",
    get: function () {
      return (0, _dateFns.parse)((0, _get2.default)(this.data, 'createdAt'));
    }

    /**
     * has contact
     * @return {boolean}
     */
  }, {
    key: "hasContact",
    get: function () {
      return !(0, _isEmpty2.default)((0, _get2.default)(this.data, 'contact', {}));
    }

    /**
     * contact
     * @return {Object}
     */
  }, {
    key: "contact",
    get: function () {
      return (0, _orderContact.orderContactFactory)((0, _get2.default)(this.data, 'contact'));
    }

    /**
     * has travellers
     * @return {boolean}
     */
  }, {
    key: "hasTravellers",
    get: function () {
      return !(0, _isEmpty2.default)((0, _get2.default)(this.flight, 'traveller', []));
    }

    /**
     * order status code
     * @return {number}
     */
  }, {
    key: "status",
    get: function () {
      return (0, _get2.default)(this.data, 'status');
    }

    /**
     * payment status
     * @return {number}
     */
  }, {
    key: "paymentStatus",
    get: function () {
      return (0, _get2.default)(this.data, 'paymentStatus');
    }

    /**
     * checks whether the order is still processing
     * @return {boolean}
     */
  }, {
    key: "isProcessing",
    get: function () {
      return this.status !== _constants2.BOOKING_STATUS.SUCCESS;
    }

    /**
     * order total
     * @return {number}
     */
  }, {
    key: "total",
    get: function () {
      return (0, _get2.default)(this.data, 'totals.total', 0);
    }

    /**
     * order id
     * @return {string}
     */
  }, {
    key: "orderId",
    get: function () {
      return (0, _get2.default)(this.data, 'orderId', '');
    }

    /**
     * subtotal price
     * @return {string}
     */
  }, {
    key: "displayedBaseSubtotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.subtotal, 2);
    }

    /**
     * order total
     * @return {string}
     */
  }, {
    key: "displayedBaseTotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.total, 2);
    }

    /**
     * order total (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedTotal",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.total);
    }

    /**
     * subtotal price
     * @return {number}
     */
  }, {
    key: "subtotal",
    get: function () {
      return (0, _get2.default)(this.data, 'totals.subtotal', 0);
    }

    /**
     * subtotal After Discount
     * @return {number}
     */
  }, {
    key: "subtotalAfterDiscount",
    get: function () {
      return (0, _get2.default)(this.data, 'displayTotals.subTotalAfterDiscount');
    }

    /**
     * subtotal After Discount
     * @return {number}
     */
  }, {
    key: "displayedBaseSubtotalAfterDiscount",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.subtotalAfterDiscount, 2);
    }

    /**
     * displayed subtotal After Discount
     * @return {number}
     */
  }, {
    key: "displayedSubtotalAfterDiscount",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.subtotalAfterDiscount);
    }

    /**
     * order total (formatted value without conversion)
     * @return {string}
     */
  }, {
    key: "orderTotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.total, 2);
    }

    /**
     * value added tax
     * @return {number}
     */
  }, {
    key: "vat",
    get: function () {
      return (0, _get2.default)(this.data, 'totals.outputVatMeta');
    }

    /**
     * has vat
     * @return {number}
     */
  }, {
    key: "hasVat",
    get: function () {
      return this.vat > 0;
    }

    /**
     * value added tax
     * @return {string}
     */
  }, {
    key: "displayedBaseVat",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.vat, 2);
    }

    /**
     * value added tax (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedVat",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.vat);
    }

    /**
     * order display currency
     * @return {string}
     */
  }, {
    key: "currency",
    get: function () {
      return (0, _get2.default)(this.data, 'displayCurrency', '');
    }

    /**
     * order currency
     * @return {string}
     */
  }, {
    key: "orderCurrency",
    get: function () {
      return (0, _get2.default)(this.data, 'currency', '');
    }

    /**
     * applied coupon code
     * @return {string}
     */
  }, {
    key: "coupon",
    get: function () {
      return (0, _get2.default)(this.data, 'coupon', '');
    }

    /**
     * order total USD
     * @return {string}
     */
  }, {
    key: "orderTotalUsd",
    get: function () {
      return (0, _get2.default)(this.data, 'orderTotalUsd');
    }

    /**
     * list of products
     * @return {number}
     */
  }, {
    key: "products",
    get: function () {
      return (0, _get2.default)(this.data, 'products', []);
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "validProducts",
    get: function () {
      return this.products.filter(_cartProduct2.isValidProduct);
    }

    /**
     * coupon products
     * @return {Array<Object>}
     */
  }, {
    key: "coupons",
    get: function () {
      const couponFactory = (0, _couponProduct.makeCouponProductFactory)(this.$env.currency.convertAndFormatPrice);
      return this.products.filter(_cartProduct2.isCouponProduct).map(couponFactory);
    }

    /**
     * valid coupon products
     * @return {Array<Object>}
     */
  }, {
    key: "validCoupons",
    get: function () {
      const couponFactory = (0, _couponProduct.makeCouponProductFactory)(this.$env.currency.convertAndFormatPrice);
      return this.validProducts.filter(_cartProduct2.isCouponProduct).map(couponFactory);
    }

    /**
     * includeTotalWithVat price
     * @return {number}
     */
  }, {
    key: "includeTotalWithVat",
    get: function () {
      var _this$data, _this$data$displayIte;
      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$displayIte = _this$data.displayItems) === null || _this$data$displayIte === void 0 ? void 0 : _this$data$displayIte.includeTotalWithVat;
    }

    /**
     * subtotal price
     * @return {number}
     */
  }, {
    key: "subtotalWithVat",
    get: function () {
      var _this$data$displayIte2, _this$data$displayIte3, _head2;
      const productItem = (_this$data$displayIte2 = this.data.displayItems) === null || _this$data$displayIte2 === void 0 ? void 0 : (_this$data$displayIte3 = _this$data$displayIte2.lineItems) === null || _this$data$displayIte3 === void 0 ? void 0 : _this$data$displayIte3.filter(product => !!(0, _cartProduct.getCartPredicate)(product.type));
      return (_head2 = (0, _head3.default)(productItem)) === null || _head2 === void 0 ? void 0 : _head2.price.totalWithVat;
    }

    /**
     * rule products
     * @return {Array<Object>}
     */
  }, {
    key: "rules",
    get: function () {
      const ruleFactory = (0, _ruleProduct.makeRuleProductFactory)(this.$env.currency.convertAndFormatPrice);
      return this.products.filter(_cartProduct2.isRuleProduct).map(ruleFactory);
    }

    /**
     * valid rule products
     * @return {Array<Object>}
     */
  }, {
    key: "validRules",
    get: function () {
      const ruleFactory = (0, _ruleProduct.makeRuleProductFactory)(this.$env.currency.convertAndFormatPrice);
      return this.validProducts.filter(_cartProduct2.isRuleProduct).map(ruleFactory);
    }

    /**
     * loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "loyalties",
    get: function () {
      const loyaltyFactory = (0, _loyaltyProduct.makeLoyaltyProductFactory)(this.$env.currency.convertAndFormatPrice, this.$env.currency.currentCurrency);
      return this.products.filter(_cartProduct2.isLoyaltyProduct).map(loyaltyFactory);
    }

    /**
     * valid loyalty products
     * @return {Array<Object>}
     */
  }, {
    key: "validLoyalties",
    get: function () {
      const loyaltyFactory = (0, _loyaltyProduct.makeLoyaltyProductFactory)(this.$env.currency.convertAndFormatPrice, this.$env.currency.currentCurrency);
      return this.validProducts.filter(_cartProduct2.isLoyaltyProduct).map(loyaltyFactory);
    }

    /**
     * wallet product total
     * @return {number}
     */
  }, {
    key: "walletTotal",
    get: function () {
      const walletProduct = (0, _head3.default)(this.products.filter(_cartProduct2.isWalletProduct));
      return Math.abs((0, _get2.default)(walletProduct, 'price.total', 0));
    }

    /**
     * wallet product total (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedWalletTotal",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.walletTotal);
    }

    /**
     * legacy flight product (TODO - remove it)
     * @return {Object}
     */
  }, {
    key: "flight",
    get: function () {
      const unformattedFlightProduct = (0, _head3.default)(this.products.filter(_cartProduct2.isFlightProduct));
      return (0, _flightProduct.flightProductFactory)(unformattedFlightProduct);
    }

    /**
     * flight product (TODO - update its name to be flight)
     * @return {Object}
     */
  }, {
    key: "flightProduct",
    get: function () {
      const flightProduct = (0, _head3.default)(this.products.filter(_cartProduct2.isFlightProduct));
      return (0, _flightProduct2.default)({
        flightProduct,
        $currency: this.$env.currency
      });
    }

    /**
     * has a hotel product
     * @return {boolean}
     */
  }, {
    key: "hasHotelProduct",
    get: function () {
      return this.validProducts.some(_cartProduct2.isHotelProduct);
    }

    /**
     * hotel raw product
     * @return {Object}
     */
  }, {
    key: "hotelRawProduct",
    get: function () {
      return (0, _last2.default)(this.validProducts.filter(_cartProduct2.isHotelProduct)) || {};
    }

    /**
     * hotel product
     * @return {Object}
     */
  }, {
    key: "hotel",
    get: function () {
      const hotelFactory = (0, _hotelProduct.makeHotelProductFactory)(this.$env.config.isRtl, this.$env.config.language);
      return hotelFactory(this.hotelRawProduct, this.$env.currency.convertAndFormatPrice);
    }

    /**
     * guest
     * @return {Object}
     */
  }, {
    key: "guests",
    get: function () {
      const guests = (0, _get2.default)(this.hotelRawProduct, 'traveller', []);
      return guests.map(_hotelProduct.guestFactory);
    }
  }, {
    key: "trackId",
    get:
    /**
     * track id
     * @return {string}
     */
    function () {
      return (0, _get2.default)(this.data, 'trackId', '');
    }

    /**
     * allowed payment methods
     * @return {string}
     */
  }, {
    key: "allowedPaymentMethods",
    get: function () {
      return (0, _get2.default)(this.data, 'allowedPaymentMethods', []).map(m => m.provider);
    }

    /**
     * returns merchant id for apple pay header
     * @returns {String}
     */
  }, {
    key: "appleMIdHeader",
    get: function () {
      var _this$data2, _this$data2$allowedPa, _this$data2$allowedPa2;
      return (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : (_this$data2$allowedPa = _this$data2.allowedPaymentMethods) === null || _this$data2$allowedPa === void 0 ? void 0 : (_this$data2$allowedPa2 = _this$data2$allowedPa.find(x => x.applemid)) === null || _this$data2$allowedPa2 === void 0 ? void 0 : _this$data2$allowedPa2.applemid;
      // const applePaymentMethod = _get(this.data, 'allowedPaymentMethods', []);
      // return _get(applePaymentMethod.applemid, false);
    }

    /**
     * allowed card payment methods
     * @return {string}
     */
  }, {
    key: "paymentCardOption",
    get: function () {
      const cardMethods = [CHECKOUTCOM, PAYFORT, TAJAWAL_PAY, FORT];
      const allowedCardMethods = (0, _intersection2.default)(this.allowedPaymentMethods, cardMethods);
      return (0, _head3.default)(allowedCardMethods);
    }

    /**
     * checks if the order is already paid
     * @return {boolean}
     */
  }, {
    key: "isPaidOrder",
    get: function () {
      return this.paidWithBank || this.paidWithCreditCard || this.paidWithKnet;
    }

    /**
     * checks if payment done through KNET
     * @return {boolean}
     */
  }, {
    key: "paidWithKnet",
    get: function () {
      return !!(0, _get2.default)(this.data, 'additionalData.knet.referenceId') && !!(0, _get2.default)(this.data, 'additionalData.knet.paymentId') && !!(0, _get2.default)(this.data, 'additionalData.knet.merchantId');
    }

    /**
     * checks if payment done through Card
     * @return {boolean}
     */
  }, {
    key: "paidWithCreditCard",
    get: function () {
      return [CHECKOUTCOM, PAYFORT, FORT].includes((0, _get2.default)(this.data, 'payment.paymentMethod'));
    }

    /**
     * checks if payment done through Bank
     * @return {boolean}
     */
  }, {
    key: "paidWithBank",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.paymentMethod') === PAY_LATER && !!(0, _get2.default)(this.data, 'payment.referenceId');
    }

    /**
     * knet payment object
     * @return {string}
     */
  }, {
    key: "knet",
    get: function () {
      return (0, _orderKnet.orderKnetFactory)((0, _get2.default)(this.data, 'additionalData.knet'));
    }

    /**
     * customer id
     * @return {string}
     */
  }, {
    key: "customerId",
    get: function () {
      return (0, _get2.default)(this.data, 'customerId');
    }

    /**
     * has customer id
     * @return {boolean}
     */
  }, {
    key: "hasCustomerId",
    get: function () {
      return !!this.customerId;
    }

    /**
     * has reward
     * @return {boolean}
     */
  }, {
    key: "hasReward",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.hasReward', false);
    }

    /**
     * reward method
     * @return {string}
     */
  }, {
    key: "rewardMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.method', '');
    }

    /**
     * reward value
     * @return {number}
     */
  }, {
    key: "rewardValue",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardValue', 0);
    }

    /**
     * reward points
     * @return {number}
     */
  }, {
    key: "rewardPoints",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardPoints', this.rewardValue);
    }

    /**
     * reward points
     * @return {string}
     */
  }, {
    key: "rewardExpiryDate",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardExpiryDate', '');
    }

    /**
     * reward identifier
     * @return {string}
     */
  }, {
    key: "rewardIdentifier",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.identifier', '');
    }

    /**
     * has fursan reward
     * @return {boolean}
     */
  }, {
    key: "hasFursanReward",
    get: function () {
      return this.rewardMethod === FURSAN;
    }

    /**
     * has mokafaa reward
     * @return {boolean}
     */
  }, {
    key: "hasMokafaaReward",
    get: function () {
      return this.rewardMethod === MOKAFAA;
    }

    /**
     * has qitaf reward
     * @return {boolean}
     */
  }, {
    key: "hasQitafReward",
    get: function () {
      return this.rewardMethod === QITAF;
    }

    /**
     * has wallet reward
     * @return {boolean}
     */
  }, {
    key: "hasWalletReward",
    get: function () {
      return this.rewardMethod === WALLET;
    }

    /**
     * has redeem
     * @return {boolean}
     */
  }, {
    key: "hasRedeem",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.hasRedeem', false);
    }

    /**
     * redeem method
     * @return {boolean}
     */
  }, {
    key: "redeemMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.redeem.method', '');
    }

    /**
     * has qitaf redeem
     * @return {boolean}
     */
  }, {
    key: "hasQitafRedeem",
    get: function () {
      return this.redeemMethod === QITAF;
    }

    /**
     * has wallet redeem
     * @return {boolean}
     */
  }, {
    key: "hasWalletRedeem",
    get: function () {
      return this.redeemMethod === WALLET;
    }

    /**
     * last 4 digits in card number
     * @return {string}
     */
  }, {
    key: "last4DigitsInCardNumber",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.card.last4', '');
    }

    /**
     * card number
     * @return {string}
     */
  }, {
    key: "getCardNumber",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.card.number', '');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "accommodation",
    get:
    /**
     * accommodation
     * @return {Object}
     */
    function () {
      const accomodationRaw = (0, _head3.default)(this.products.filter(_cartProduct2.isAccommodation));
      return (0, _chalet.chaletFactory)({
        cartTotalPrice: (0, _get2.default)(this.data, 'totals', {}),
        product: accomodationRaw,
        language: this.$env.config.language,
        formatPrice: this.$env.currency.convertAndFormatPrice
      });
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data) {
      this.API_STATE = SUCCESS;
      this.data = data;
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      var _error$response$data, _error$response;
      this.API_STATE = FAILED;
      const errorResponse = (_error$response$data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : error.response;
      errorHandler(errorResponse);
    }

    /**
     * reset API state to default
     */
  }, {
    key: "resetApiState",
    value: function resetApiState() {
      this.data = {};
      this.API_STATE = INITIAL;
    }
  }]);
  return OrderStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "cartId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "modifiedCartId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "modifiedCartId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "entityType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "entityType"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderNumber", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderNumber"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "createdAt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasContact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasContact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasTravellers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTravellers"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "status", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isProcessing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isProcessing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "total", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "total"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseSubtotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseSubtotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "subtotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "subtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseSubtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseSubtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedSubtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedSubtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "vat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currency", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderCurrency", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderCurrency"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "coupon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "coupon"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderTotalUsd", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotalUsd"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "products", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "products"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validProducts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validProducts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "coupons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "coupons"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validCoupons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validCoupons"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "includeTotalWithVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "includeTotalWithVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "subtotalWithVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalWithVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rules", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rules"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validRules", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validRules"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "loyalties", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loyalties"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validLoyalties", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validLoyalties"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "walletTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "walletTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedWalletTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedWalletTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flight"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasHotelProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasHotelProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hotelRawProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelRawProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hotel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotel"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "guests", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "guests"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "trackId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "trackId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allowedPaymentMethods", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowedPaymentMethods"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appleMIdHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "appleMIdHeader"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentCardOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCardOption"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPaidOrder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaidOrder"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithKnet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithKnet"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithCreditCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithCreditCard"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithBank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithBank"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "knet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "knet"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "customerId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "customerId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasCustomerId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCustomerId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardValue"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardPoints", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardPoints"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardExpiryDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardExpiryDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardIdentifier", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardIdentifier"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasFursanReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFursanReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMokafaaReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMokafaaReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQitafReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQitafReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasWalletReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWalletReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "redeemMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeemMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQitafRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQitafRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasWalletRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWalletRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "last4DigitsInCardNumber", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "last4DigitsInCardNumber"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getCardNumber", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "getCardNumber"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getHotelOrder", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getHotelOrder({
      payload,
      errorHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = this.$env.config.isHotelNewCheckout ? yield _cart.CartClient.getOrder(payload) : yield _hotelCart.HotelCartClient.getOrder(payload);
        this.onSuccess(response);
      } catch (e) {
        this.onError(e, errorHandler);
      }
    });
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getAccommodationOrder", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getAccommodationOrder({
      payload,
      errorHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = yield _accommodationCart.AccommodationCartClient.getOrder(payload);
        this.onSuccess(response);
      } catch (e) {
        this.onError(e, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "accommodation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "accommodation"), _class.prototype), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getFlightOrder", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getFlightOrder({
      payload,
      errorHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = yield _cart.CartClient.getOrder(payload);
        this.onSuccess(response);
      } catch (e) {
        this.onError(e, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetApiState", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "resetApiState"), _class.prototype)), _class));
exports.OrderStore = OrderStore;